// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

/* Store Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import { FieldMaskOptions } from "@store/Framework/Common/Hooks/useFieldMask";
/* Store Custom Code - End */

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 2,
        /* Store Custom Code - Start */
        accountId: {
            label: () => translate("Cansel_Form_AccountId"),
            maskOptions: {
                mask: "0000000000",
            } as FieldMaskOptions,
            maxLength: 10,
            placeholder: () => "",
            regExp: new RegExp("^\\d{10}$"),
            invalidMessage: () => translate("Cansel_Form_AccountId_Invalid"),
        },
        email: {
            label: () => translate("Cansel_Form_Email"),
            placeholder: () => "",
            regExp: new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*"),
            invalidMessage: () => translate("Cansel_Form_Email_Invalid"),
        },
        phone: {
            label: () => translate("Cansel_Form_Phone"),
            maskOptions: {
                mask: "(000) 000-0000",
            } as FieldMaskOptions,
            maxLength: 14,
            placeholder: () => "(999) 999-9999",
            regExp: new RegExp("^\\(\\d{3}\\) \\d{3}-\\d{4}$"),
            invalidMessage: () => translate("Cansel_Form_Phone_Invalid"),
        },
        phoneExtension: {
            label: () => translate("Cansel_Form_PhoneExtension"),
            maskOptions: {
                mask: "000000",
            } as FieldMaskOptions,
            maxLength: 6,
            placeholder: () => "",
        },
        postalCode: {
            label: () => translate("Cansel_Form_PostalCode"),
            maskOptions: {
                mask: "a0a 0a0",
                prepareChar: x => x.toUpperCase(),
            } as FieldMaskOptions,
            maxLength: 7,
            placeholder: () => "A9A 9A9",
            regExp: new RegExp("^[a-zA-Z]\\d[a-zA-Z] \\d[a-zA-Z]\\d$"),
            invalidMessage: () => translate("Cansel_Form_PostalCode_Invalid"),
        },
        salesforce: {
            city: {
                label: () => translate("Cansel_Form_City"),
                placeholder: () => "",
                regExp: new RegExp("^[a-zA-Z][a-zA-Z-\\s]+$"),
                invalidMessage: () => translate("Cansel_Salesforce_City_Invalid"),
            },
            firstName: {
                label: () => translate("Cansel_Form_FirstName"),
                placeholder: () => "",
                regExp: new RegExp("^[a-zA-Z][a-zA-Z-\\s]+$"),
                invalidMessage: () => translate("Cansel_Salesforce_Name_Invalid"),
            },
            lastName: {
                label: () => translate("Cansel_Form_LastName"),
                placeholder: () => "",
                regExp: new RegExp("^[a-zA-Z][a-zA-Z-\\s]+$"),
                invalidMessage: () => translate("Cansel_Salesforce_Name_Invalid"),
            },
            street: {
                label: () => translate("Cansel_Form_Street"),
                placeholder: () => "",
                regExp: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9\\s]+"),
                invalidMessage: () => translate("Cansel_Salesforce_Street_Invalid"),
            },
        },
        zipCode: {
            label: () => translate("Cansel_Form_ZipCode"),
            maskOptions: {
                mask: "00000[-0000]",
            } as FieldMaskOptions,
            maxLength: 10,
            placeholder: () => "99999-9999",
            regExp: new RegExp("^\\d{5}(-\\d{4})?$"),
            invalidMessage: () => translate("Cansel_Form_ZipCode_Invalid"),
        },
        /* Store Custom Code - End */
    },
    /* Store Custom Code - Start */
    widgetGroup: {
        requestQuote: "Request Quote" as any,
        onboarding: "Onboarding" as any,
    },
    pageType: {
        requestQuote: "RequestQuotePage",
    },
    /* Store Custom Code - End */
});
